module.exports = __webpack_public_path__ + "img/harvest_3.4d359aa5.png";